import KateWoman from '../images/COSOC/Lesson 1.3/woman.jpg'
import BorisMan from '../images/COSOC/Lesson 1.3/man.jpg'
import YoungMan from '../images/COSOC/Lesson 1.3/youngman.jpg'
import YoungLady from '../images/COSOC/Lesson 1.3/younglady.jpg'
import Girl from '../images/COSOC/Lesson 1.3/girl.jpg'
import Boy from '../images/COSOC/Lesson 1.3/boy.jpg'
import man_chauffeur from '../images/COSOC/Lesson 1.3/man_chauffeur.jpg'
import woman_doctor from '../images/COSOC/Lesson 1.3/woman_doctor.jpg'
import man_engineer from '../images/COSOC/Lesson 1.3/man_engineer.jpg'
import photographer_woman from '../images/COSOC/Lesson 1.3/photographer_woman.jpg'
import architect_man from '../images/COSOC/Lesson 1.3/architect_man.jpg'
import girl_student from '../images/COSOC/Lesson 1.3/girl_student.jpg'

let _ = require("lodash");


export const set1COSOC = _.shuffle([
    {
        eng: "This is Larry Page, he is from Google",
        rus: "Это Ларри Пейдж, он из Гугл"
    },
    {
        eng: "This is Jeff Bezos, he is from Amazon",
        rus: "Это Джеф Безос, он из Амазон"
    },
    {
        eng: "This is Tim Cook, he is from Apple",
        rus: "Это Тим Кук, он из Аппл"
    },
    {
        eng: "This is Bill Gates, he is from Microsoft",
        rus: "Это Билл Гейтс, он из Майкрософт"
    },
    {
        eng: "This is Elon Musk, he is from Tesla",
        rus: "Это Илон Маск, он из Тесла"
    },
    {
        eng: "This is Jack Ma, he is from Ali Baba",
        rus: "Это Джек Ма, он из Али Баба"
    }
]);

export const set2COSOC = _.shuffle([
    {
        eng: "He is not a taxi driver, he is a minster",
        rus: "Он не таксист, он министр"
    },
    {
        eng: "She is not a politician, she is a pianist",
        rus: "Она не политик, она пианист"
    },
    {
        eng: "I am not a pilot, I am a manager",
        rus: "Я не пилот, я менеджер"
    },
    {
        eng: "You are not an actor, you are a businessman",
        rus: "Ты не актёр, ты бизнесмэн"
    },
    {
        eng: "We are not acrobats, we are performers",
        rus: "Мы не акробаты, мы артисты"
    },
    {
        eng: "They are not directors, they are gymnasts",
        rus: "Они не директора, они гимнасты"
    },
    {
        eng: "You are not journalist, you are chauffeur",
        rus: "Вы не журналист, вы шофёр"
    },
    {
        eng: "It is not a computer, it is a printer",
        rus: "Это не компьютер, это принтер"
    }
]);

export const set3COSOC = _.shuffle([
    {
        eng: "My name is Jackie Chan. I am an actor. I am from China",
        rus: "Меня зовут Джеки Чан. Я актёр. Я из Китая"
    },
    {
        eng: "Your name is Tom Hardy. You are an actor. You are from Great Britain",
        rus: "Тебя зовут Том Харди. Ты актёр. Ты из Великобритании"
    },
    {
        eng: "His name is Elon Musk. He is a manager. He is from South Africa",
        rus: "Его зовут Илон Маск. Он менеджер. Он из Южной Африки"
    },
    {
        eng: "Her name is Angela Merkel. She is a chancellor. She is from Germany",
        rus: "Её зовут Ангела Меркель, Она канцлер. Она из Германии"
    },
    {
        eng: "Its name is Samsung. It is a device. It is from South Korea",
        rus: "Его зовут Самсунг. Оно устройство. Оно из Южной Кореи"
    },
    {
        eng: "Your names are Barack and Michelle Obama. You are a couple. You are from the USA",
        rus: "Вас зовут Барак и Мишель Обама. Вы пара. Вы из США"
    },
    {
        eng: "Our names are Akio Morita and Masaru Ibuka. We are founders. We are from Japan",
        rus: "Нас зовут Акио Морита и Масару Ибука. Мы основатели. Мы из Японии"
    },
    {
        eng: "Their names are Alexandr Ovechkin and Evgeni Malkin. They are hockey players. They are from Russia",
        rus: "Их зовут Александр Овечкин и Евгений Малкин. Они хоккеисты. Они из России"
    },
    {
        eng: "My name is Luc Besson. I am a fild director. I am from France",
        rus: "Меня зовут Люк Бессон. Я режиссёр. Я из Франции"
    },
    {
        eng: "My name is Hasan Shah. I am a footballer. I am from Turkey",
        rus: "Меня зовут Хасан Шаш. Я футболист. Я из Турции"
    }
]);

// Lesson 1.3
export const set4COSOC = _.shuffle([
    {
        photo:KateWoman,
        name: 'Катя',
        rus: "Это женщина. Её зовут Катя.",
        attr:'<a href="https://www.flickr.com/photos/timothykrause/6145100685/in/photolist-an2fkP-WA6JPn-s1PiW6-Jwy4F9-236SWmh-s3dZ1w-fho4x-gQuqr-2dtzHtz-rJ2GL2-2fGMiGD-JbKimL-nXqcHV-UnmeAE-N6gfpY-V4LpeL-C8zfyy-bSy8YR-JmbbEa-fENmhP-a4Q9pi-9xY191-GMShJ-g4tz5t-WZTknJ-eCfcn-TrMted-Dw5kE4-71uB1N-Kw7QiE-CL8kxC-L8HDem-ZgKTvN-2ixSEcN-VCwDSM-aDRJkt-Fj4TuV-4NbH6-sih6nQ-ZW1c18-9H8Sjr-5rXjnT-iepfBu-JAvr56-9d8EhK-4JGbEV-63MBN-85ZVSw-4t2iSb-cHmpmy" target="_blank">"Woman"</a> by <a href="https://www.flickr.com/photos/timothykrause/" target="_blank">Timothy Krause</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:BorisMan,
        name: 'Борис',
        rus: "Это мужчина. Его зовут Борис.",
        attr:'<a href="https://www.flickr.com/photos/moyermk/4120895273/in/photolist-7h9EAv-FY83bT-aFnDNJ-dLKqoX-9heym5-9heyey-9hbpMx-pkWEWT-7z6w2E-pmceAo-84vnxQ-AEWkCB-CnCix6-23Db2qK-X5iEaS-SUDRqG-FUbFN3-2h9tt8A-p4JM98-ydZbv6-2h9sE3H-bqXrA6-ciirrA-pkTbDM-pmdUzM-p4F8DL-fHgbs4-D1vpCR-4waCyh-4waBiy-5LbN1E-4w1vsK-46HUPC-mVBk2H-2j3uz2J-2hi4FuP-E6mSk-rhyXZ8-cg1e57-7LPVwv-4w1uW4-GFsxwv-vMW4Aa-vQPX6D-2g2gKDS-w6FYJr-6VhUgn-7AD7ws-SbjS2s-89xpnd" target="_blank">"Filipino Man"</a> by <a href="https://www.flickr.com/photos/moyermk/" target="_blank">moyerphotos</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:YoungMan,
        name: 'Джим',
        rus: "Это молодой человек. Его зовут Джим.",
        attr:'<a href="https://www.flickr.com/photos/gagilas/4027306412/in/photolist-78SZTs-T3Av1x-21NyvF9-bSS6Uc-RZ45tK-bDXomu-zgX6Vf-bDXpCE-bDXoHC-LN4LfF-23t1ciw-X8WowV-2fhXjTk-21TQfWj-23CZh3f-28wm9fE-akgPoH-Ws9dLt-nQkCYU-2iiuEM8-2isbJEv-dNYUYK-o1epN9-sSsB1A-2cr2Va7-SXnjiC-249uQFN-H2PjGk-2eBEfhC-KKGMnp-EvVqtp-dM1h13-LpVUHL-LiatdU-2gXAfmu-291RfhJ-2iReWG2-K6mNRU-yc3aGH-Jprgym-6Kjy8d-2b6eYyr-9kkQL5-2cw5CXb-2iGSC4R-CtmpKr-2iXxw89-WMGJ2W-2i2G46q-yQrXo3" target="_blank">"Orifejus once again"</a> by <a href="https://www.flickr.com/photos/gagilas/" target="_blank">Petras Gagilas</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:YoungLady,
        name: 'Вероника',
        rus: "Это девушка. Её зовут Вероника.",
        attr:'<a href="https://www.flickr.com/photos/128621707@N08/16938244149/in/photolist-rNLVSe-9dkbZf-EgZPQM-EFPcPj-SsCZ57-FGPXFP-z7iMGG-EgSjN5-Ky6ho-TiFGW6-PDS26J-TZBesr-Huudzh-FTf2uo-SdLzgu-zBwR4h-QPY1bs-23MZEC7-yGiV9U-dGLq6h-QefvxR-242QaYP-azfUen-VKTQWY-Y8i2fx-JpiUue-26DyX1d-9AQUnF-WqEPgL-2bWK4GX-ZgwzMZ-2i34Jds-R1MKar-azfTjk-2imEdv1-Hcda1H-VrFBTH-Y8i2Sp-djwBU-efiq3q-MYhVDH-PTsmqE-VPPm5m-24aBriC-XqUgJJ-RJKBVF-GAuYfd-2igpsvH-29kavvh-YF9bin" target="_blank">"Young Lady Front Portrait"</a> by <a href="https://www.flickr.com/photos/128621707@N08/" target="_blank">Arno Hoyer</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:Girl,
        name: 'Мария',
        rus: "Это девочка. Её зовут Мария.",
        attr:'<a href="https://www.flickr.com/photos/philocycler/29940728270/in/photolist-MBL4oW-Q7zFvb-PTHsrz-4qmsG2-BBVyNE-wA76CB-2bKG5nk-2fV2L5Q-DvZ73h-pRAqzV-VH1jLk-bBPqur-sq42u3-oA8Bhk-jKeVE1-gkX1Te-tquWb2-UuJfBR-Cop5Hx-hNhpRf-foBYiG-w6eGVf-wKPez6-oiZK1s-7MLUU2-trQqyG-o4i6cS-8bUNfj-Yz2r8k-7d6HSN-9cKEyo-pznBSJ-xsLPoC-eYLWsj-rhNJnV-gkXjRu-VR3RDc-WTwUHv-Hn9GyL-Hs3b1C-aPEwrc-oM5XKG-8828Cz-8bHFYQ-7njLdn-bkNDSV-7dgV94-CwPcKo-dibzKS-6aE6Cx" target="_blank">"girl"</a> by <a href="https://www.flickr.com/photos/philocycler/" target="_blank">John</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:Boy,
        name: 'Дэвид',
        rus: "Это мальчик. Его зовут Дэвид.",
        attr:'<a href="https://www.flickr.com/photos/afgmatters/4284338573/in/photolist-7wAmAr-8SZveS-qJM511-g8mzkt-7B2Nqq-cvFF37-bzYfKB-2gsHzNX-jSLHT-nvPsuq-rCQScA-9k1NWr-8EJb1J-366u8k-ps3AiJ-e2dQD1-Tx5Ngj-vmJRav-B1neys-Uggwst-6QdY6p-ewXzhi-7voY4e-54TFyH-7wzq6K-w7u7cj-Hf4hw-Hf71X-Hf4kN-5YaBYG-8ss7xJ-Hf1Zr-KCfHk-Hf72n-e7mfQ-Hf4kj-KC9iu-9pF1YM-HeXEH-Hf6Zr-aQoRti-2wdvoT-7EGqKP-8K5JYR-UexoCQ-rkwYut-w3QGoy-DDvETp-yqxdtw-6S2WnD" target="_blank">"Boy"</a> by <a href="https://www.flickr.com/photos/afgmatters/" target="_blank">Afghanistan Matters</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    }
]);

// Lesson 1.3
export const set5COSOC = _.shuffle([
    {
        photo:man_chauffeur,
        name: 'Луис',
        rus: "Это мужчина. Его зовут Луис. Он шофёр",
        attr:'<a href="http://flickr.com/photos/46308641@N08/5951983550/in/photolist-a4Xtm3-6Q6RLZ-7oiXZg-2ugPWg-P4Kt1M-XSXde4-cUSmpb-zFavjK-ozH7Gz-pc5tfz-F1kAyg-zrihk-25riQmu-rrqWtB-DGXXFU-GiR3Ku-2hGibe8-rCQU6E-e61r1p-2dRZVrq-JDSkKR-25xLHeo-suopqX-9u9Cjt-91ybrC-ogtNDi-9rcd4s-2gSK2AB-22fYTuf-Wo8THf-Xv8ugz-2hbXueg-yPrGVs-WwLvKJ-5WNstS-aayVpp-4HrALR-5vkrBh-4HvP8s-4HvP9L-p1uYVy-dMkqsb-66u1eC-XzLSBQ-zqRV1r-3Wwog-9GXFVd-ja9iFy-25Duv3W-fCCPxc" target="_blank">"The chauffeur"</a> by <a href="https://www.flickr.com/photos/46308641@N08/" target="_blank">Lucy Harper</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:woman_doctor,
        name: 'Кристина',
        rus: "Это женщина. Её зовут Кристина. Она доктор",
        attr:'<a href="https://www.flickr.com/photos/kioko/4750068036/in/photolist-8eKkJL-a7vC1-65qhH-bZh75E-6hJUyr-as9MT1-aFeCat-aLAMa2-4k2hab-bxRvei-7zGR9D-6dyh18-6dxRx8-6dxRuB-6dxRyP-9P1jui-bzzBBc-MPGqo-bcnrB4-4FgJfr-bkYFJg-5Fjomm-5SjTtq-KPPsu-6LvKP1-GdMTz-ahq1DS-dhup7L-eJySEq-21r2eeU-5vHg6i-ajv8EH-xGwTM-E9iQRt-oaHcsG-9tnKyJ-AS43z-nTnDGp-2g8gvYc-NS39Po-vt7oQc-o8P7EY-23gcPY7-9GTvdz-24h4kkM-27K8itW-RncuyL-bCGBEu-bCGzDU-bCGxad" target="_blank">"Doctor"</a> by <a href="https://www.flickr.com/photos/kioko/" target="_blank">David Blumenkrantz</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:man_engineer,
        name: 'Пит',
        rus: "Это мужчина. Его зовут Пит. Он инженер",
        attr:'<a href="https://www.flickr.com/photos/107803477@N08/14040049856/in/photolist-nqqRBM-dsrGcF-noEVF7-uG1q1-dcJzEY-nstQcM-ntfsbN-QBgp7z-axjFx4-nKrZxk-nYVWk4-7csNYv-Av4iCG-nqqBVD-nqpYkj-nGJxf2-YqFFCS-6jX6Rb-nqqGJ6-nqHcL6-noF1pq-Z7xYqb-nqFEev-nKrZaB-Mb6SvX-nKrYNz-Z7y5bE-nsuv2F-noEKbE-7RH3Vn-nqJuj3-7RM1nb-5Pp8g6-5Pp1An-oHWVAW-g7ynaP-nKGJ6w-fKu5Rb-7sKR9v-kYSZGR-7RHQDX-7RLbgE-o4LiDw-nqraUE-nG9DW7-7RGHAe-nqHzwv-noEExm-7e2NNQ-7RHZvi" target="_blank">"BDUK Cumbria Sellafield9"</a> by <a href="https://www.flickr.com/photos/107803477@N08/" target="_blank">BTs BDUK partnerships fibre rollout photography</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:photographer_woman,
        name: 'Дэбби',
        rus: "Это девушка. Её зовут Дэбби. Она фоторгаф",
        attr:'<a href="https://www.flickr.com/photos/chrishunkeler/9121744395/in/photolist-eU4jP6-6R1pnY-4XnLoK-bv1HP-5rrCD4-68ttjk-8oKsSW-68tsWv-5GGEmi-adX7ve-8CFyN-644T3C-68xFUJ-4nePbt-2cChbgx-adZW3o-gsgq6-28ucN9V-2htHpgf-mQLP6x-eQRDdZ-AqqdCY-cMdvT3-2iHVmaq-a2bGfp-FNKVZf-HKhNsD-bDvnBu-tzimKL-e3cVFA-cMdxeo-cQ8mMu-EuEtCj-bkD78F-nwQxiS-aYDY4-SKW8qu-apLyL2-dKMuyx-65efWX-nRrDZZ-2bAZjt2-2wq2kX-hWG6y-3ymWzA-66KYg4-Jxzf6R-wXKkuM-CRVsCr-LLzLu" target="_blank">"Volunteer Photographer"</a> by <a href="https://www.flickr.com/photos/chrishunkeler/" target="_blank">Chris Hunkeler</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:architect_man,
        name: 'Оскар',
        rus: "Это мужчина. Его зовут Оскар. Он архитектор",
        attr:'<a href="https://www.flickr.com/photos/eager/15948604750/in/photolist-qijLxY-bW9RFC-bW9SQb-bW9Qyq-bW9WNy-bW9PDU-bW9XLw-bRkSi4-bRm44c-bCr8uo-bRkXJ2-bCrb3J-bCrfXJ-bCrw3Q-bCrdx9-bCruG3-bCriUb-bRm9Mg-bCrnGS-bCrkKW-bRkVin-bCrtW7-bRm6Jk-bRm8xV-8wqkTh-bauPJv-2gWayYb-aQDW8X-qzGZBp-RK8c2-bv1HV5-bDD9Ds-2j3oMyp-qmtrA-7qaJT-8JQSe5-pCSMjS-DBSnrS-orxqo8-orwYPA-6Lwzi4-aLoCET-oHZPYm-orwTYT-oFZSry-2ikkw93-orxpuz-DvuLp4-orwX5T-orxo2e" target="_blank">"Alvaro Siza - architect portrait"</a> by <a href="https://www.flickr.com/photos/eager/" target="_blank">準建築人手札網站 Forgemind ArchiMedia</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    },
    {
        photo:girl_student,
        name: 'Лиза',
        rus: "Это девушка. Её зовут Лиза. Она студентка",
        attr:'<a href="https://www.flickr.com/photos/eager/15948604750/in/photolist-qijLxY-bW9RFC-bW9SQb-bW9Qyq-bW9WNy-bW9PDU-bW9XLw-bRkSi4-bRm44c-bCr8uo-bRkXJ2-bCrb3J-bCrfXJ-bCrw3Q-bCrdx9-bCruG3-bCriUb-bRm9Mg-bCrnGS-bCrkKW-bRkVin-bCrtW7-bRm6Jk-bRm8xV-8wqkTh-bauPJv-2gWayYb-aQDW8X-qzGZBp-RK8c2-bv1HV5-bDD9Ds-2j3oMyp-qmtrA-7qaJT-8JQSe5-pCSMjS-DBSnrS-orxqo8-orwYPA-6Lwzi4-aLoCET-oHZPYm-orwTYT-oFZSry-2ikkw93-orxpuz-DvuLp4-orwX5T-orxo2e" target="_blank">"Alvaro Siza - architect portrait"</a> by <a href="https://www.flickr.com/photos/eager/" target="_blank">準建築人手札網站 Forgemind ArchiMedia</a>, <a>russian-course</a>, <a href="https://www.flickr.com/" target="_blank">flickr</a> is licensed under <a href="http://creativecommons.org/licenses/by/4.0" target="_blank">CC BY 4.0</a>'
    }
])


// Lesson 2.1
export const set6COSOC = _.shuffle([
    {
        eng: "I am a banker. I have worked in the bank for 1 year ",
        rus: "Я банкир. Я работаю в банке один год"
    },
    {
        eng: "You are an actor. You have worked in the theater for 2 years",
        rus: "Ты актёр. Ты работаешь в театре два года"
    },
    {
        eng: "She is a secretary. She has worked in the office for 3 years",
        rus: "Она секретарь. Она работает в офисе три года"
    },
    {
        eng: "He is a professor. He has worked in the university for 4 years",
        rus: "Он профессор. Он работает в университете четыре года"
    },
    {
        eng: "You are a deputy. You have worked in the parliament for 5 years",
        rus: "Вы депутат. Вы работаете в парламенте пять лет"
    },
    {
        eng: "I am a doctor. I have worked in the hospital for six years",
        rus: "Я доктор. Я работаю в больнице шесть лет"
    },
    {
        eng: "He is a teacher. He has worked at school for seven years",
        rus: "Он учитель. Он работает в школе семь лет"
    }
]);

// Lesson 2.1
export const set7COSOC = _.shuffle([
    {
        eng: "I work as a banker in a bank",
        rus: "Я работаю банкиром в банке"
    },
    {
        eng: "You work as an actor in the theatre",
        rus: "Ты работаешь актёром в театре"
    },
    {
        eng: "She works as a secretary in the office",
        rus: "Она работает секретарём в офисе"
    },
    {
        eng: "He works as a professor in the university",
        rus: "Он работает профессором в университете"
    },
    {
        eng: "You work as a deputy in the parliament",
        rus: "Вы работаете депутатом в парламенте"
    },
    {
        eng: "They work as doctors in the hospital",
        rus: "Они работают врачами в больнице"
    },
    {
        eng: "We work as teachers at the school",
        rus: "Мы работаем учителями в школе"
    }
]);

// Lesson 2.1
export const set8COSOC = _.shuffle([
    {
        eng: "I have breakfast at home, have lunch at the cafe, and have dinner at the bar",
        rus: "Я завтракаю дома, обедаю в кафе и ужинаю в баре"
    },
    {
        eng: "You have breakfast at work, have lunch at the food court, and have dinner at the cafe",
        rus: "Ты завтракаешь на работе, обедаешь в фудкорте и ужинаешь в кафе"
    },
    {
        eng: "He has breakfast at the pizzeria, has lunch at the restaurant, and has dinner at home",
        rus: "Он завтракает в пицерии, обедает в ресторане и ужинает дома"
    },
    {
        eng: "You have breakfast at work, have lunch at the cafe shop, and have dinner at the restaurant",
        rus: "Вы завтракаете на работе, обедаете в кафешопе и ужинаете в ресторане"
    },
    {
        eng: "We have breakfast at the restaurant, have lunch at the cafeteria, and have dinner at the pizzeria",
        rus: "Мы завтракаем в ресторане, обедаем в кафетерии и ужинаем в пицерии"
    },
    {
        eng: "They have breakfast at the cafe shop, have lunch at the canteen, and have dinner at the bar",
        rus: "Они завтракают в кафешопе, обедают в столовой и ужинают в баре"
    }
]);
